import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  SET_NEW_PASSWORD,
  SET_NEW_PASSWORD_AFTER_EXPIRE,
  SET_NEW_PASSWORD_SUCCESS,
  RESET_FORGET_PASSWORD,
} from "./actionTypes";

export const userForgetPassword = (user, history) => {
  return {
    type: FORGET_PASSWORD,
    payload: { user, history },
  };
};

export const userForgetPasswordSuccess = (message) => {
  return {
    type: FORGET_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const setNewPsw = (user, history, pswToken) => {
  return {
    type: SET_NEW_PASSWORD,
    payload: { user, history, pswToken },
  };
};

export const setNewPswAfterExpire = (user, history, pswToken) => {
  return {
    type: SET_NEW_PASSWORD_AFTER_EXPIRE,
    payload: { user, history, pswToken },
  };
};

export const setNewPswSuccess = (message) => {
  return {
    type: SET_NEW_PASSWORD_SUCCESS,
    payload: message,
  };
};

export const resetForgetPassword = () => {
  return {
    type: RESET_FORGET_PASSWORD,
    payload: {},
  };
};

export const apiError = (error) => {
  return {
    type: FORGET_PASSWORD_ERROR,
    payload: error,
  };
};
